// The five unitat balance cards (hidden entirely for unitat-scoped users).

import { useFactures } from './useFacturesContext';
import { FACTURES_UNITATS } from '../../constants/roles';
import { fmtEUR } from './facturesTypes';
import {
	CardBalance,
	CardNom,
	CardOwed,
	SummaryCard,
	SummaryGrid,
} from './Factures.styles';

export const SummaryCards = () => {
	const fac = useFactures();
	return (
		<SummaryGrid>
			{FACTURES_UNITATS.map((u) => {
				const s = fac.summary?.[u.id];
				const owed = s?.owed?.filter((o) => o.owedCents !== 0) ?? [];
				const owedTotal = owed.reduce((a, o) => a + o.owedCents, 0);
				return (
					<SummaryCard
						key={u.id}
						$selected={fac.selected === u.id}
						onClick={() => fac.openUnitat(u.id)}
					>
						<CardNom>{u.nom}</CardNom>
						<CardBalance $negative={(s?.balanceCents ?? 0) < 0}>
							{s ? fmtEUR(s.balanceCents) : '0,00 €'}
						</CardBalance>
						<CardOwed>
							{owedTotal > 0
								? `Pendent de tornar: ${fmtEUR(owedTotal)}`
								: owedTotal < 0
									? `Pendent de rebre: ${fmtEUR(-owedTotal)}`
									: 'Cap pendent'}
						</CardOwed>
					</SummaryCard>
				);
			})}
		</SummaryGrid>
	);
};
